import { render, staticRenderFns } from "./setting-create-duplicate-company-config.vue?vue&type=template&id=5a8e14a9&scoped=true"
import script from "./setting-create-duplicate-company-config.vue?vue&type=script&lang=js"
export * from "./setting-create-duplicate-company-config.vue?vue&type=script&lang=js"
import style0 from "./setting-create-duplicate-company-config.vue?vue&type=style&index=0&id=5a8e14a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e14a9",
  null
  
)

export default component.exports